<div *ngIf="hasFiltri"  class="card-body align-middle">
  <div class="row align-middle">
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">{{'lavorazioni.inizio' | translate}}</label>
      <input type="date" #inizio = "ngModel"  [(ngModel)]="Filtri.inizio" (ngModelChange)="refreshTable(1)" name="inizio" class="form-control">
    </div>
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">{{'lavorazioni.fine' | translate}}</label>
      <input type="date" #fine = "ngModel"  [(ngModel)]="Filtri.fine" (ngModelChange)="refreshTable(1)" name="fine" class="form-control">
    </div>
    <div class="col-lg-1 align-middle">
      <label class="control-label col-form-label">{{'lavorazioni.periodo' | translate}}</label>
      &nbsp;
      <input type="checkbox" #periodo = "ngModel" [(ngModel)]="Filtri.periodo" (ngModelChange)="refreshTable(1)" name="periodo" >
    </div>
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">{{'lavorazioni.brand' | translate}}</label>
      <input type="text" #fine = "ngModel"  [(ngModel)]="Filtri.brand" (ngModelChange)="refreshTable(1)" name="text" class="form-control">
    </div>
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">{{'lavorazioni.prodotto' | translate}}</label>
      <input type="text"   [(ngModel)]="Filtri.prodotto" (ngModelChange)="refreshTable(1)" name="text" class="form-control">
    </div>
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">{{'lavorazioni.brandizzato' | translate}}</label>
      <ng-multiselect-dropdown [settings]="DropdownSettings" [placeholder]="'lavorazioni.brandizzato' | translate" id="brandizzato"
                               [data]="brandizzatifilter" [(ngModel)]="Filtri.bransizzatiSelected" (ngModelChange)="refreshTable(1)" >
      </ng-multiselect-dropdown>
    </div>
<!--    <div class="col-lg-1 align-middle">-->
<!--      <label class="control-label col-form-label">{{'lavorazioni.gruppo' | translate}}</label>-->
<!--      &nbsp;-->
<!--      <input type="checkbox" #periodo = "ngModel" [(ngModel)]="Filtri.gruppo" (ngModelChange)="refreshTable(1)" name="periodo" >-->
<!--    </div>-->

    <div class="col-sm-12 col-md-3">
      <div class="form-group">
        <label for="fornitore" class="control-label col-form-label">{{'lavorazioni.stati' | translate}}</label>
        <ng-multiselect-dropdown [settings]="DropdownSettings" [placeholder]="'lavorazioni.stati' | translate" id="fornitore"
                                 [data]="Stati" [(ngModel)]="StatiSelezionati" (ngModelChange)="refreshTable(1)" >
        </ng-multiselect-dropdown>
      </div>
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center bg-white p-3">
   <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{'menu.lavorazioni' | translate}}:</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
   </span>
  <div class="ml-auto mt-3 mt-md-0">
<!--    <button *ngIf="permission.isPermitted('gestione-acquisti') && isAddEnabled" (click)='Edit()' type="button" class="btn btn-cyan rounded-pill py-2" ><i-->
<!--      class="fas fa-plus  font-14 mr-1 text-white"></i>-->
<!--      <span class="ml-1 text-white font-weight-bold">{{'lavorazioni.add' | translate}}</span>-->
<!--    </button>-->
    <div class="ml-auto mt-3 mt-md-0">
      <app-stampa [Stampe]="stampe" *ngIf="stampe && stampe.length > 0" [(data)]="List"></app-stampa>
    </div>
    <button type="button" class="btn btn-info rounded-pill py-2" (click)='ImportaStock()' ><i
      class="fas fa-download font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">{{'acquisti.stockImport.title' | translate}}</span>
    </button>
    <button type="button" class="btn btn-info rounded-pill py-2" (click)='ImportaProd()' ><i
      class="fas fa-download font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">{{'acquisti.prodImport.title' | translate}}</span>
    </button>
  </div>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0">
    <thead>
    <tr>
      <th scope="col" >
        <input type="checkbox" [(ngModel)]="SelectAll" name="list_name" value="h1" (change)="checkUncheckAll()" />
      </th>
      <th>{{'lavorazioni.voce' | translate}}</th>
      <th scope="col">{{'lavorazioni.brand' | translate}}</th>
      <th scope="col">{{'lavorazioni.dordine' | translate}}</th>
      <th scope="col">Ordine</th>
      <th scope="col">{{'lavorazioni.Stock-Spedizioni' | translate}}</th>
      <th scope="col">{{'lavorazioni.produzione' | translate}}</th>
      <th scope="col">{{'lavorazioni.quantita' | translate}}</th>
      <th scope="col">{{'lavorazioni.stock' | translate}}</th>

      <th scope="col" *ngIf="permission.isPermitted('gestione-lavorazioni')">{{'lavorazioni.azioni' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of List | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
      <td  class="align-middle"  >
        <input type="checkbox" [(ngModel)]="item.isSelected" name="list_name" (change)="CheckIfAllSelected()" />
      </td>
      <td (click)='Edit(item)'>
        <span class="font-14">{{item.voce.includes(',') ? item.voce.substr(0,item.voce.indexOf(',')-1) : item.voce}}</span>
      </td>
      <td class="align-middle" (click)='Edit(item)'>
        <span class="font-14">{{item.brand}}</span>
      </td>
      <td class="align-middle" (click)='Edit(item)'>
        <span class="font-14">{{ item.data_ordine | date: 'dd/MM/yyyy'}}</span>
      </td>
      <td class="align-middle" (click)='Edit(item)'>
        <span class="font-14">{{ item.anno}} / {{item.progressivo}}</span>
      </td>
      <td class="align-middle" (click)='Edit(item)'>
        <span class="font-14">{{item.disponibilita}}</span>
      </td>
      <td class="align-middle" (click)='Edit(item)'>
        <span class="font-14">{{item.produzione}}</span>
      </td>
      <td class="align-middle" (click)='Edit(item)'>
        <span class="font-14">{{item.quantita}}</span>
      </td>
      <td class="align-middle" (click)='Edit(item)'>
        <span class="font-14">{{item.stock}}</span>
      </td>


      <td class="align-middle">
        <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
           (click)="Edit(item)">
          <i class="fas fa-pencil-alt"></i>
        </a>
<!--        <a href="javascript:void(0)" ngbTooltip="Elimina"-->
<!--           class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>-->
<!--          <i class="fas fa-trash-alt"></i>-->
<!--        </a>-->
      </td>
    </tr>
    </tbody>
  </table>
</div>


<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
                  [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>


